import { Dispatcher } from 'flux';

const HeroBuildDispatcher = Object.assign(new Dispatcher(), {
  NAME: 'HERO_BUILD_DISPATCHER',

  CREATE_NEW_HERO_BUILD: 'CREATE_NEW_HERO_BUILD',
  COPY_HERO_BUILD: 'COPY_HERO_BUILD',
  DELETE_HERO_BUILD: 'DELETE_HERO_BUILD',
  ENGAGE_HERO_BULID: 'ENGAGE_HERO_BUILD',
  FOCUS_HERO_BUILD: 'FOCUS_HERO_BUILD',
  ABILITY_CHANGED: 'ABILITY_CHANGED',
  RENAME_HERO_BULID: 'RENAME_HERO_BULID',

  handleHeroBuildAction: function(action) {
    this.dispatch({
      source: HeroBuildDispatcher.NAME,
      action
    });
  }
});
export default HeroBuildDispatcher;
